// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Part } from './part';
import { PartAliasType } from './part-alias-type';
import { PurchaseOrderLineItem } from './purchase-order-line-item';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartAlias extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  cost!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  displayOrder?: number;
  packageQuantity?: string;
  partAliasTypeId!: number;
  partId!: number;
  partNumber?: string;
  quickBooksLineItemId?: number;
  vendorId!: number;
  part!: Part;
  partAliasType!: PartAliasType;
  quickBooksLineItem!: PurchaseOrderLineItem;
  vendor!: Vendor;
}

